import { I } from '@angular/cdk/keycodes';
import { Component, Input, OnInit } from '@angular/core';

export const PRZYCISK_PROSTOKAT_TYP = {
  MALY: 'maly',
  DUZY: 'duzy'
};

export const PRZYCISK_PROSTOKAT_RODZAJ = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  PRZEZROCZYSTY: 'przezroczysty'
};

@Component({
  selector: 'mm-przycisk-prostokatny',
  templateUrl: './przycisk-prostokatny.component.html',
  styleUrls: ['./przycisk-prostokatny.component.scss']
})
export class PrzyciskProstokatnyComponent implements OnInit {

  @Input() typ = PRZYCISK_PROSTOKAT_TYP.MALY;
  @Input() label = '';
  @Input() disabled = false;
  @Input() rodzaj = PRZYCISK_PROSTOKAT_RODZAJ.SECONDARY;
  @Input() ikonaNaPoczatku?: string;
  @Input() ikonaNaKoncu?: string;
  @Input() paddingX = '25px';
  @Input() paddingY = '0px';
  @Input() iconHeight = '40%';
  /**
   * Konstruktor
   * @param ikonySvgSerwis - serwis ładowania ikon
   * @param eRef - referencja do komponentu
   */
  constructor() {
  }

  /**
   * Cykl życia komponentu inicjalizacja
   */
  ngOnInit(): void {

  }

}
